<template>
    <div class="main-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">修改考核计划</h1>
        </div>
        <div class="content">
            <a-form
                    :form="form"
                    @submit="handleSubmit"
                    :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 16 }"
                    :colon="false"
                    style="width: 50%;margin: auto"
            >
                <a-row>
                    <a-col :lg="24" :md="24" :sm="24">
                        <TextareaField :modelValue="text.name" required labelWidth="10%" style="margin: 0.5rem 0.2rem" label="计划名称" id="name"
                                       @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                        />
                    </a-col>

                    <a-col :lg="24" :md="24" :sm="24">
                        <RangePickerField labelWidth="10%" label="考核时间" :modelValue="text.time" required
                                          :placeholder="['开始时间', '结束时间']" :disabled="false"
                                          @update:modelValue="(value) => handleModelValueUpdate('time', value)"/>
                    </a-col>

                    <a-col :lg="24" :md="24" :sm="24">
                        <SelectField style="margin: 0.5rem 0.2rem" labelWidth="10%" label="考核人员" required :options="userList"
                                     :modelValue="text.users" id="type" placeholder="考核人员"
                                     multiple type-info="version2"
                                     @update:modelValue="(value) => handleModelValueUpdate('users', value)"
                        />
                    </a-col>

                    <a-col :lg="24" :md="24" :sm="24">
                        <TextareaField :modelValue="text.remark" labelWidth="10%" style="margin: 0.5rem 0.2rem" label="备注" id="remark"
                                       @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                        />
                    </a-col>
                </a-row>

                <div class="center">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                    </a-space>
                </div>
            </a-form>
        </div>
    </div>
</template>
<script>
import { fetchList } from "@/api/setting/user";
import { edit } from "@/api/personnel-assess";
import moment from "moment";

export default {
  data() {
    return {
      form: {
          name:null,
          time:[],
          users:[],
          remark:null
      },
      userList: [],
      userList1:[],
      text: {},
      saveLoading: false,
    };
  },

  mounted() {
    fetchList({
      pageNum: 1,
      pageSize: 999,
    }).then((res) => {
      if (Array.isArray(res.list)) {
          this.userList1 = res.list
          this.userList = res.list.map(item => ({
              value: item.id,
              name: item.name,
          }));
      }
    });

    const text = this.$route.query;
    if (!text.id) return;

    const userList = Array.isArray(text.userList) ? text.userList : [];

    this.text = {
      ...text,
      time: [moment(text.timeBegin), moment(text.timeEnd)],
      users: userList.map((item) => item.userId),
    };
  },

  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    cancel() {
      this.$router.go(-1);
    },

    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.form.name) {
            this.$message.error('任务名称不能为空');
            this.isSubmitting = false; // 重置标志
            return;
        }
        if (!this.form.time) {
            this.$message.error('任务类型不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.users) {
            this.$message.error('任务类型不能为空');
            this.isSubmitting = false;
            return;
        }

        let timeBegin, timeEnd;
        if (Array.isArray(this.form.time) && this.form.time.length === 2) {
            if (this.form.time[0] && typeof this.form.time[0].format === 'function') {
                timeBegin = this.form.time[0].format("YYYY-MM-DD");
            } else {
                timeBegin = this.form.time[0];
            }

            if (this.form.time[1] && typeof this.form.time[1].format === 'function') {
                timeEnd = this.form.time[1].format("YYYY-MM-DD");
            } else {
                timeEnd = this.form.time[1];
            }
        }

          const userList = [];
          this.form.users.forEach((id) => {
              const obj = this.userList1.find((item) => item.id === id);
              if (obj) {
                userList.push({
                  userId: id,
                  userName: obj.name,
                });
              }
            });
            console.log("this.text::::",this.text)
            edit({
              id: this.text.id,
              ...this.form,
              timeBegin,
              timeEnd,
              time: undefined,
              userList,
              users: undefined,
            })
              .then(() => {
                this.$router.go(-1);
              })
              .finally(() => {
                this.isSubmitting = false;
              });
          }
  },
};
</script>

<style lang="less" scoped>
.center {
  padding-bottom: 24px;
}
/* 主内容区 */
.main-container {
    padding:2rem 0;
    width: 80%;
    margin: auto;
}

/* 页面标题 */
.page-header {
    margin-bottom: 2rem;
}

.page-title {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.content{
    background: rgba(20, 35, 70, 0.5);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}
</style>
